import { Component, OnInit } from '@angular/core';
import {ExcRestService} from 'exc-rest';
import {ExcTranslation} from 'exc-core';
import {ExcListConfig} from 'exc-controls';
import {ExcTab} from 'exc-tab';
import {OrderDetailsComponent} from '../order-details/order-details.component';
@Component({
  selector: 'app-order-finished',
  templateUrl: './order-finished.component.html',
  styles: []
})
export class OrderFinishedComponent extends  ExcTranslation implements OnInit {

  orderlistconfig: ExcListConfig = new ExcListConfig();
  searchValue: string = null;
  data: any[] = [];
  constructor(private excRest: ExcRestService) {
    super();
    const _self = this;
    _self.orderlistconfig.selectionMode = 'none';
    _self.orderlistconfig.paging = {pagingTotalRows: 1, pagingTotalPages: 1, pagingPage: 1, pagingPageSize: 10};
    _self.orderlistconfig.OnSearch = function (searchValue, event?) {
      _self.searchValue = searchValue || '';
      _self.initialLoad();
    };
    _self.orderlistconfig.OnPageChanged = (pageNo, event1) => {
      _self.orderlistconfig.paging.pagingPage = pageNo;
      _self.initialLoad();
    };
    _self.orderlistconfig.OnRefresh = () => {
      _self.initialLoad();
    };
    _self.orderlistconfig.OnDetailLink = (item, event?) => {
      new ExcTab(item.OrdVertragsnummer, OrderDetailsComponent, item, item.OrdId, {
        Unique: true, ReloadParent: function () {
          // _self.initialLoad();
        }
      }, true).Open();
   };
  }

  initialLoad () {
    const _self = this;
    const url = _self.excRest.computeUrl('OrderFinishedR_List', {fts: this.searchValue == null ? '' : this.searchValue});
    const mi = this.orderlistconfig.GetMetaInfo();
    mi.dataSort = {'OrdAbschlussDatum': 'desc'};
    _self.orderlistconfig.isLoading = true;
    _self.excRest.get(url, {MetaInfo: mi}).subscribe(ret => {
      if (ret) {
        _self.data = ret.data;
        _self.orderlistconfig.paging = ret.paging;
        _self.orderlistconfig.isLoading = false;
      }
    });
  }
  ngOnInit() {
    this.initialLoad();
  }

}
